<template>
  <b-container fluid class="mt-4">
    <h1>
      Update
      <b>{{userName}}</b> Profile
    </h1>
    <b-tabs pills card vertical>
      <b-tab title="Personal Info" active>
        <b-row>
          <b-col cols="6">
            <b-form-group>
              <b-row>
                <b-col cols="4">
                  <label>
                    First Name
                    <span class="required-span">*</span>
                  </label>
                </b-col>
                <b-col cols="8">
                  <b-form-input
                    v-model="$v.form.firstname.$model"
                    :state="$v.form.firstname.$dirty ? !$v.form.firstname.$error : null"
                    type="text"
                    size="sm"
                    placeholder="Enter Your First Name"
                  ></b-form-input>
                  <b-form-invalid-feedback>This field is required</b-form-invalid-feedback>
                </b-col>
              </b-row>
            </b-form-group>

            <b-form-group>
              <b-row>
                <b-col cols="4">
                  <label>
                    Last Name
                    <span class="required-span">*</span>
                  </label>
                </b-col>
                <b-col cols="8">
                  <b-form-input
                    v-model="$v.form.lastname.$model"
                    :state="$v.form.lastname.$dirty ? !$v.form.lastname.$error : null"
                    placeholder="Enter Your Last Name"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback>This field is required</b-form-invalid-feedback>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <ProfileImageUpload />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-button class="float-right" type="button" @click="onSubmit" variant="primary">Update</b-button>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="Update Password">
        <UpdatePassword />
      </b-tab>
    </b-tabs>
  </b-container>
</template>
<script>
import { HTTP } from "../../utils/HTTP";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import UpdatePassword from "./updatePassword.vue";
import ProfileImageUpload from "../../components/employeeComponents/profileImageUpload.vue";
import { Helper } from "../../helpers";
export default {
  name: "UpdateEmployeeProfile",
  mixins: [validationMixin],
  components: {
    ProfileImageUpload,
    UpdatePassword,
  },
  data() {
    return {
      profileImage: null,
      isLoading: false,
      userDetail: null,
      userName: null,
      form: {
        userName: null,
        firstname: null,
        lastname: null,
      },
    };
  },
  validations: {
    form: {
      firstname: {
        required,
      },
      lastname: {
        required,
      },
    },
  },
  mounted() {
    this.setUserDetail();
  },
  methods: {
    setUserDetail() {
      let datail = JSON.parse(localStorage.getItem("userDetail"));
      this.userDetail = datail;
      this.userName = datail.first_name + " " + datail.last_name;
      this.profileImage = datail.profile_img_url;
      this.form = {
        userName: datail.username,
        firstname: datail.first_name,
        lastname: datail.last_name,
      };
    },
    makeSuccessToster() {
      Helper.makeToast(this.$bvToast, "success", "Successfully Updated");
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      } else {
        this.uploadProfileApiCall().then(this.getUserDetail);
      }
    },
    async uploadProfileApiCall() {
      let formData = {
        contact_id: this.userDetail.contact_id,
        first_name: this.form.firstname,
        last_name: this.form.lastname,
        profile_img_url: this.$store.state.profileImageBaseContent,
        user_id: localStorage.getItem("userId"),
      };
      try {
        await HTTP("post", "api/v1/contact/update-profile", formData);
        this.makeSuccessToster();
      } catch (err) {
        return [err];
      }
    },
    async getUserDetail() {
      localStorage.removeItem("userDetail");
      this.isLoading = true;
      try {
        let result = await HTTP(
          "get",
          "api/v1/user/detail/" + this.userDetail.id,
          null
        );
        let userData = JSON.stringify(result.data);
        localStorage.setItem("userDetail", userData);
        this.setUserDetail();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";
</style>